import React, { useEffect, useState } from "react";
import { RESTExecutor, withDomains } from "../../lib/domain";
import { Form, Input, Button, message } from "antd";
import { LockOutlined, CheckOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";

function parseQueryParameters(url) {
  var queryParams = {};
  var queryString = url.substring(url.indexOf("?") + 1);
  var pairs = queryString.split("&");

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    queryParams[key] = value;
  }

  return queryParams;
}

const customStyles = `
  :root { --basic-input-height: 40px !important; }
  .reset-password-form .ant-form-item { margin-bottom: 0 !important; }
  .reset-password-form .ant-form-item-label { padding: 0 !important; margin-bottom: 4px !important; }
  .reset-password-form .ant-form-item-label > label {
    color: #636972 !important; font-size: 12px !important; font-family: 'Inter' !important;
    font-weight: 500 !important; height: auto !important; line-height: normal !important;
  }
  .reset-password-form .ant-form-item-label > label::after { display: none !important; }
  .reset-password-form .ant-input {
    background: #FAFAFA !important; border: none !important; border-radius: 6px !important;
    height: 40px !important; min-height: 40px !important; max-height: 40px !important;
    font-size: 12px !important; font-family: 'Inter' !important; font-weight: 400 !important;
    color: #343C46 !important; padding: 8px 16px !important; outline: 1px #E0E5EB solid !important;
    outline-offset: -1px !important; box-shadow: none !important; line-height: 1.2 !important;
  }
  .reset-password-form .ant-input:focus, .reset-password-form .ant-input:hover {
    outline: 1px #E0E5EB solid !important; outline-offset: -1px !important;
    box-shadow: none !important; border: none !important;
  }
  .reset-password-form .ant-input::placeholder {
    color: #BFC3C9 !important; font-size: 12px !important; font-family: 'Inter' !important; font-weight: 400 !important;
  }
  .reset-password-form .ant-input-affix-wrapper {
    background: #FAFAFA !important; border: none !important; border-radius: 6px !important;
    height: 40px !important; min-height: 40px !important; max-height: 40px !important;
    padding: 8px 16px !important; outline: 1px #E0E5EB solid !important; outline-offset: -1px !important;
    box-shadow: none !important; line-height: 1.2 !important;
  }
  .reset-password-form .ant-input-affix-wrapper:focus, .reset-password-form .ant-input-affix-wrapper:hover,
  .reset-password-form .ant-input-affix-wrapper-focused {
    outline: 1px #E0E5EB solid !important; outline-offset: -1px !important;
    box-shadow: none !important; border: none !important;
  }
  .reset-password-form .ant-input-affix-wrapper .ant-input {
    background: transparent !important; border: none !important; outline: none !important;
    box-shadow: none !important; padding: 0 !important; height: auto !important; line-height: 1.2 !important;
  }
  .reset-password-form .ant-input-affix-wrapper .ant-input:focus {
    box-shadow: none !important; border: none !important; outline: none !important;
  }
  .reset-password-form .ant-form-item-explain-error {
    color: #E82E49 !important; font-size: 12px !important; font-family: 'Inter' !important; margin-top: 4px !important;
  }
  .reset-password-form .invalid-input { outline: 1px #E82E49 solid !important; outline-offset: -1px !important; }
  .reset-password-form .ant-input-suffix { margin-left: 8px !important; }
  .password-indicator {
    width: 12px; height: 12px; border-radius: 2.24px; display: flex; align-items: center; justify-content: center;
    font-size: 8px; color: white; font-weight: bold;
  }
  .password-indicator.valid { background: #1DB954; }
  .password-indicator.invalid { background: #E82E49; border-radius: 50%; width: 8px; height: 8px; }
  .login-text-link {
    color: var(--Main-blue, #143E9F) !important; font-size: 12px !important; font-family: 'Inter' !important;
    font-weight: 700 !important; line-height: 18px !important; cursor: pointer !important; text-decoration: none !important;
  }
  .login-text-link:hover { text-decoration: underline !important; color: var(--Main-blue, #143E9F) !important; }
  @media (max-width: 768px) {
    .reset-password-container { padding-left: 20px !important; padding-right: 20px !important; }
  }
`;

const ResetPasswordPage = ({ domains, authenticator, ...props }) => {
  const { search } = useLocation();
  const history = useHistory();

  var queryParams = parseQueryParameters(search);
  const [tValue, setTValue] = useState(queryParams["t"]);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  
  useEffect(() => {
    // Clear all authentication tokens
    localStorage.removeItem('token');
    localStorage.removeItem('authToken');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    localStorage.removeItem('userInfo');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('userInfo');    
    Object.keys(localStorage).forEach(key => {
      if (key.toLowerCase().includes('auth') || key.toLowerCase().includes('token')) {
        localStorage.removeItem(key);
      }
    });
    Object.keys(sessionStorage).forEach(key => {
      if (key.toLowerCase().includes('auth') || key.toLowerCase().includes('token')) {
        sessionStorage.removeItem(key);
      }
    });
    
    // Force logout to ensure we're in unauthenticated state
    if (authenticator && authenticator.isAuthenticated()) {
      authenticator.logout();
    }
  }, [authenticator]);

  var eValue = queryParams["e"];
  var hValue = queryParams["h"];

  const validatePassword = (password) => {
    if (!password) return false;
    const passwordPattern = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()])[A-Za-z\d!@#$%^&*()]{8,20}$/;
    return passwordPattern.test(password);
  };

  const getPasswordIndicator = (password) => {
    if (!password) return null;
    const isValid = validatePassword(password);
    return (
      <div className={`password-indicator ${isValid ? 'valid' : 'invalid'}`}>
        {isValid ? <CheckOutlined style={{ fontSize: '8px' }} /> : ''}
      </div>
    );
  };

  const getConfirmPasswordIndicator = (password, confirmPassword) => {
    if (!confirmPassword) return null;
    const isMatch = password && confirmPassword && password === confirmPassword && validatePassword(password);
    return (
      <div className={`password-indicator ${isMatch ? 'valid' : 'invalid'}`}>
        {isMatch ? <CheckOutlined style={{ fontSize: '8px' }} /> : ''}
      </div>
    );
  };

  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleConfirmPasswordChange = (e) => setConfirmPassword(e.target.value);

  const isFormValid = () => {
    return validatePassword(password) && password === confirmPassword && password && confirmPassword;
  };

  useEffect(() => {
    const regex = /t=([^&]+)/;
    const match = search.match(regex);

    if (match) {
      setTValue(parseInt(match[1]));
    }
  }, []);

  let check_expiry = RESTExecutor.list()
    .config({
      label: "check_expiry",
    })
    .connect(domains.password);

  useEffect(() => {
    check_expiry
      .config({
        params: {
          t: `${tValue}`,
          h: `${hValue}`,
          e: `${eValue}`,
        },
      })
      .execute();
  }, []);
  let expiry_response = check_expiry.response();
  console.log(expiry_response, "hello");

  const currentTime = Math.floor(Date.now() / 1000);

  const hasTimePassed = tValue !== 0 ? currentTime >= tValue : false;

  const [reset_password_form] = Form.useForm();

  let reset_password = RESTExecutor.post()
    .config({
      label: "reset_password",
    })
    .callbacks(
      (success) => {
        message.success(
          "Password changed successfully. Please login to your account."
        );
        props.history.push("/");
      },
      (error) => {
        console.log(error, "hello error");
      }
    )
    .forId(props.location.search)
    .connect(domains.password);

  const onFinish = (formData) => {
    if (!validatePassword(formData.new_password)) {
      message.error("Password must contain at least one capital letter, one special character, one number, and be 8 to 20 characters long.");
      return;
    }
    if (formData.new_password !== formData.confirm_password) {
      message.error("Passwords do not match.");
      return;
    }
    reset_password.execute(formData);
  };

  let { validation_errors = {}, error_message } = reset_password.response();
  let validateStatus =
    Object.keys(validation_errors || {}).length > 0 ? "error" : undefined;
  validateStatus = error_message ? "error" : undefined;

  if (hasTimePassed || (!expiry_response.isFetching && expiry_response.error)) {
    history.push("/reset-password-link-expired");
  }

  return (
    <>
      <style>{customStyles}</style>
      <div
        className="reset-password-container"
        style={{
          width: '100vw',
          height: '100vh',
          paddingLeft: 280,
          paddingRight: 280,
          background: '#EEF2F7',
          overflow: 'hidden',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex'
        }}
      >
        <div
          style={{
            width: 544,
            paddingLeft: 32,
            paddingRight: 32,
            paddingTop: 40,
            paddingBottom: 40,
            background: '#FAFAFA',
            boxShadow: '0px 28px 62px rgba(37, 78, 207, 0.03)',
            borderRadius: 16,
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: 18,
            display: 'flex'
          }}
        >
          <div style={{
            alignSelf: 'stretch',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: 24,
            display: 'flex'
          }}>
            <div style={{
              flex: '1 1 0',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
              gap: 2,
              display: 'flex'
            }}>
              <div style={{
                alignSelf: 'stretch',
                color: '#343C46',
                fontSize: 24,
                fontFamily: 'Inter',
                fontWeight: '700',
                wordWrap: 'break-word'
              }}>
                Reset Password
              </div>
              <div style={{
                color: '#636972',
                fontSize: 12,
                fontFamily: 'Inter',
                fontWeight: '400',
                wordWrap: 'break-word'
              }}>
                Please enter your new password.
              </div>
            </div>
            <img
              src="images/tigg_logo.png"
              style={{
                width: 'auto',
                height: '33.18px'
              }}
              alt="Tigg Logo"
            />
          </div>

          <div style={{
            alignSelf: 'stretch',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: 16,
            display: 'flex',
          }}>
            <Form
              requiredMark={false}
              colon={false}
              form={reset_password_form}
              name="reset-password"
              className="reset-password-form"
              onFinish={onFinish}
              layout="vertical"
              style={{ width: '100%' }}
            >
              <div style={{
                alignSelf: 'stretch',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: 24,
                display: 'flex'
              }}>
                <div style={{
                  alignSelf: 'stretch',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  gap: 8,
                  display: 'flex'
                }}>
                  <div style={{
                    alignSelf: 'stretch',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 12,
                    display: 'flex'
                  }}>
                    <div style={{
                      alignSelf: 'stretch',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                      gap: 4,
                      display: 'flex',
                      paddingBottom: 8,
                    }}>
                      <div style={{
                        color: '#636972',
                        fontSize: 12,
                        fontFamily: 'Inter',
                        fontWeight: '500',
                        wordWrap: 'break-word'
                      }}>
                        New Password*
                      </div>

                      <Form.Item
                        name="new_password"
                        style={{ alignSelf: 'stretch', width: '100%' }}
                        validateStatus={validateStatus}
                        help={
                          (validation_errors?.new_password ?? [null])[0] ||
                          error_message
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please input your Password!",
                          },
                          {
                            pattern:
                              /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()])[A-Za-z\d!@#$%^&*()]{8,20}$/,
                            message:
                              "Must contain at least one capital letter, one special character, one number, and be 8 to 20 characters long.",
                          },
                        ]}
                      >
                        <Input.Password
                          prefix={<LockOutlined />}
                          suffix={getPasswordIndicator(password)}
                          placeholder="****************"
                          onChange={handlePasswordChange}
                        />
                      </Form.Item>

                      <div style={{
                        color: '#636972',
                        fontSize: 12,
                        fontFamily: 'Inter',
                        fontWeight: '500',
                        wordWrap: 'break-word'
                      }}>
                        Confirm Password*
                      </div>

                      <Form.Item
                        name="confirm_password"
                        style={{ alignSelf: 'stretch', width: '100%' }}
                        dependencies={['new_password']}
                        validateStatus={validateStatus}
                        help={
                          (validation_errors?.confirm_password ?? [null])[0] ||
                          error_message
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please retype your new password!",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value || getFieldValue("new_password") === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error(
                                  "The two passwords that you entered do not match!"
                                )
                              );
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          prefix={<LockOutlined />}
                          suffix={getConfirmPasswordIndicator(password, confirmPassword)}
                          placeholder="****************"
                          onChange={handleConfirmPasswordChange}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{
                alignSelf: 'stretch',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: 24,
                display: 'flex'
              }}>
                <div style={{
                  alignSelf: 'stretch',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  gap: 8,
                  display: 'flex'
                }}>
                  <Button
                    loading={reset_password.response()?.fetching}
                    htmlType="submit"
                    disabled={!isFormValid()}
                    style={{
                      alignSelf: 'stretch',
                      paddingLeft: 16,
                      paddingRight: 16,
                      paddingTop: 12,
                      paddingBottom: 12,
                      background: isFormValid() ? 'var(--Main-blue, #143E9F)' : '#CBD0D6',
                      boxShadow: '0px 8px 24px -8px rgba(20, 62, 159, 0.16)',
                      overflow: 'hidden',
                      borderRadius: 6,
                      border: 'none',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: 8,
                      display: 'flex',
                      color: 'white',
                      fontSize: 12,
                      fontFamily: 'Inter',
                      fontWeight: '600',
                      lineHeight: '18px',
                      cursor: isFormValid() ? 'pointer' : 'not-allowed',
                      height: 'auto'
                    }}
                  >
                    Reset Password
                  </Button>

                  <div 
                    style={{
                      alignSelf: 'stretch',
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                      padding: '12px 16px',
                      gap: 8,
                    }}
                  >
                    <span style={{
                      color: '#343C46',
                      fontSize: 12,
                      fontFamily: 'Inter',
                      fontWeight: '500',
                      lineHeight: '18px',
                      wordWrap: 'break-word'
                    }}>
                      Remember your Password?{' '}
                    </span>
                    <span 
                      className="login-text-link"
                      onClick={() => history.push("/")}
                    >
                      Log in
                    </span>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default withDomains(ResetPasswordPage, "password");
